exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ssn-input-container.text-input-error .ssn-input-wrapper{border:1px solid red}.ssn-input-wrapper{height:40px;border:1px solid #e6e4e4;border-radius:4px;background-color:#fff;display:flex}.ssn-input-wrapper div{padding-left:20px;display:flex;align-items:center;margin:auto auto auto 5px}.ssn-input-wrapper div input{border:0;outline:0;background:rgba(0,0,0,0);border-bottom:1px solid #292929;text-align:center;padding-left:5px}.ssn-input-wrapper div .ssn-input-field1{width:48px}.ssn-input-wrapper div .ssn-input-field2{width:40px}.ssn-input-wrapper div .ssn-input-field3{width:59px}", ""]);

// exports
